import api from './api';
import { ComissaoColaborador } from '../types/comissaoColaborador';
import { ToastContainer, toast } from 'react-toastify';

export interface Apolice {
  id: number;
  numero: string;
  produto?: string;
  status: 'Ativa' | 'Cancelada' | 'Vencida' | 'Renovação';
  proposta?: string;
  dataEmissao?: string;
  seguradoraAnterior?: {
    id: number;
    nome: string;
  };
  dataVenda:string,
  apoliceAnterior?: string;
  formaPagamento?: 'CRÉDITO' | 'DÉBITO' | 'PIX' | 'BOLETO';
  propostaAssinada?: boolean;
  apoliceConferida?: boolean;
  dataInicio: string;
  dataFim: string;
  premioBruto: number | string;
  premioLiquido: number;
  premioTotal: number | null;
  quantidadeParcelas: number;
    comissaoVendedor: number | null;
  comissaoCorretora: number | null;
  repasse: number;
  iof: number | string;
  cliente: {
    id: number;
    nome: string;
    dataNascimento?: string;
    profissao?: string;
  };
  seguradora: {
    id: number;
    nome: string;
  };
  ramo: {
    id: number;
    nome: string;
  };
  vendedor?: {
    id: number;
    nome: string;
  };
  corretora?: {
    id: number;
    nome: string;
  };
  createdAt: string;
  updatedAt: string;
  dataPrimeiroPagamento?: string | null;
  dataSegundoPagamento?: string | null;
  ci?:string
}

export interface CreateApoliceDTO {
  numero?: string;
  produto?: string;
  status: 'Ativa' | 'Cancelada' | 'Vencida' | 'Renovação';
  proposta?: string;
  dataEmissao?: string | null;
  seguradoraAnterior?: { id: number };
  apoliceAnterior?: string;
  formaPagamento?: 'CRÉDITO' | 'DÉBITO' | 'PIX' | 'BOLETO';
  propostaAssinada?: boolean;
  apoliceConferida?: boolean;
  dataInicio: string;
  dataFim: string;
  dataVenda:string;
  premioBruto: number | string;
  premioLiquido: number;
  quantidadeParcelas: number;
    comissaoVendedor: number | null;
  comissaoCorretora: number | null;
  repasse?: number;
  iof: number | string;
  cliente: { id: number };
  seguradora: { id: number };
  ramo: { id: number };
  vendedor?: { id: number };
  corretora?: { id: number };
  dataPrimeiroPagamento?: string | null;
  dataSegundoPagamento?: string | null;
  gerarParcelasAutomaticamente?: boolean;
  ci?:string
}

export const apoliceService = {
  listar: async (filtros: any, page: number = 1, limit: number = 10): Promise<{ data: Apolice[], total: number, page: number, limit: number }> => {
    try {
      const params = {
        ...filtros,
        page,
        limit,
      };
      // Remove chaves de filtro nulas ou vazias
      Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);

      const response = await api.get('/apolices', { params });
      return response.data;
    } catch (error:Error | any) {

      throw new Error(error.message)
     
    }
    
  },

  buscarPorId: async (id: number): Promise<Apolice> => {
    const response = await api.get(`/apolices/${id}`);
    return response.data;
  },

  getApolice: async (id: number): Promise<Apolice> => {
    const response = await api.get(`/apolices/${id}`);
    return response.data;
  },

  criar: async (apolice: CreateApoliceDTO): Promise<Apolice> => {

    if(apolice.dataEmissao==="") apolice.dataEmissao=null;
    const response = await api.post('/apolices', apolice);
    return response.data;
  },

  atualizar: async (id: number, apolice: CreateApoliceDTO): Promise<Apolice> => {
    console.log("mostrando dados")
    console.log(apolice)
    if(apolice.dataEmissao==="") apolice.dataEmissao=null;
    
    const response = await api.put(`/apolices/${id}`, apolice);
    return response.data;
  },

  updateApolice: async (id: number, apolice: any): Promise<Apolice> => {
    const response = await api.put(`/apolices/${id}`, apolice);
    return response.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`/apolices/${id}`);
  },

  listarComissoesColaborador: async (apoliceId: number): Promise<ComissaoColaborador[]> => {
    const response = await api.get(`/apolices/${apoliceId}/comissoes-colaborador`);
    return response.data;
  },

  atualizarComissaoColaborador: async (apoliceId: number, comissaoId: number, dados: Partial<ComissaoColaborador>): Promise<ComissaoColaborador> => {
    const response = await api.put(`/apolices/${apoliceId}/comissoes-colaborador/${comissaoId}`, dados);
    return response.data;
  },

  excluirComissaoColaborador: async (apoliceId: number, comissaoId: number): Promise<void> => {
    await api.delete(`/apolices/${apoliceId}/comissoes-colaborador/${comissaoId}`);
  },

  listarPorCliente: async (clienteId: number): Promise<Apolice[]> => {
    const response = await api.get(`/clientes/${clienteId}/apolices`);
    return response.data;
  },



}; 